import { Production } from '@features/productions';
import { Box, Button, Card, Flex, Text } from '@radix-ui/themes';

import { ProductionAvatar } from './ProductionAvatar';
import styles from './ProductionCard.module.css';

interface ProductionCardProps {
    production: Production;
    onSelected: (production: Production) => void;
}

export const ProductionCard = ({
    production,
    onSelected,
}: ProductionCardProps) => {
    return (
        <Card
            style={{ backgroundColor: 'transparent' }}
            className={styles.container}
            asChild
        >
            <Button
                className={styles.button}
                variant={'outline'}
                onClick={() => onSelected(production)}
                style={{
                    height: 'auto',
                    minHeight: '100%',
                    padding: 0,
                    overflow: 'hidden',
                }}
            >
                <Flex align={'center'} width={'100%'}>
                    <ProductionAvatar
                        production={production}
                        size={'7'}
                        radius={'none'}
                    />

                    <Box flexGrow={'1'} px={'4'} style={{ minWidth: 0 }}>
                        <Text
                            as='div'
                            align='left'
                            color='gray'
                            highContrast
                            className={styles.name}
                            style={{
                                whiteSpace: 'normal',
                                wordWrap: 'break-word',
                            }}
                        >
                            {production.name}
                        </Text>
                    </Box>
                </Flex>
            </Button>
        </Card>
    );
};
